import { render, staticRenderFns } from "./LeadGooseSecondModal.vue?vue&type=template&id=97fb4cb2&scoped=true&"
import script from "./LeadGooseSecondModal.vue?vue&type=script&lang=js&"
export * from "./LeadGooseSecondModal.vue?vue&type=script&lang=js&"
import style0 from "./LeadGooseSecondModal.vue?vue&type=style&index=0&id=97fb4cb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fb4cb2",
  null
  
)

export default component.exports